import {
  GET_SCHOOL_DATA_REQUESTED,
  GET_SCHOOL_DATA_SUCCESSFUL,
  GET_SCHOOL_DATA_FAILED,
  GET_SCHOOL_COURSES_REQUESTED,
  GET_SCHOOL_COURSES_SUCCESSFUL,
  GET_SCHOOL_COURSES_FAILED,
  GET_COURSE_DETAILS_REQUESTED,
  GET_COURSE_DETAILS_SUCCESSFUL,
  GET_COURSE_DETAILS_FAILED,
  GET_COURSE_MODULES_REQUESTED,
  GET_COURSE_MODULES_SUCCESSFUL,
  GET_COURSE_MODULES_FAILED,
  GET_SOCIALS_REQUESTED,
  GET_SOCIALS_SUCCESSFUL,
  GET_SOCIALS_FAILED,
  GET_FORUMS_REQUESTED,
  GET_FORUMS_SUCCESSFUL,
  GET_FORUMS_FAILED,
  SET_FORUMS_DATA,
  GET_FORUMS_SUMMARY_REQUESTED,
  GET_FORUMS_SUMMARY_SUCCESSFUL,
  GET_FORUMS_SUMMARY_FAILED,
  GET_FORUMS_UNANSWERED_REQUESTED,
  GET_FORUMS_UNANSWERED_SUCCESSFUL,
  GET_FORUMS_UNANSWERED_FAILED,
  SET_FORUMS_UNANSWERED_DATA,
  GET_QUESTION_DATA_REQUESTED,
  GET_QUESTION_DATA_SUCCESSFUL,
  GET_QUESTION_DATA_FAILED,
  SUBMIT_FORUM_QUESTION_REQUESTED,
  SUBMIT_FORUM_QUESTION_SUCCESSFUL,
  SUBMIT_FORUM_QUESTION_FAILED,
  SUBMIT_FORUM_COMMENT_REQUESTED,
  SUBMIT_FORUM_COMMENT_SUCCESSFUL,
  SUBMIT_FORUM_COMMENT_FAILED,
  SUBMIT_FORUM_ANSWER_REQUESTED,
  SUBMIT_FORUM_ANSWER_SUCCESSFUL,
  SUBMIT_FORUM_ANSWER_FAILED,
  UPVOTE_FORUM_QUESTION_REQUESTED,
  UPVOTE_FORUM_QUESTION_SUCCESSFUL,
  UPVOTE_FORUM_QUESTION_FAILED,
  DOWNVOTE_FORUM_QUESTION_REQUESTED,
  DOWNVOTE_FORUM_QUESTION_SUCCESSFUL,
  DOWNVOTE_FORUM_QUESTION_FAILED,
  UPVOTE_FORUM_ANSWER_REQUESTED,
  UPVOTE_FORUM_ANSWER_SUCCESSFUL,
  UPVOTE_FORUM_ANSWER_FAILED,
  DOWNVOTE_FORUM_ANSWER_REQUESTED,
  DOWNVOTE_FORUM_ANSWER_SUCCESSFUL,
  DOWNVOTE_FORUM_ANSWER_FAILED,
  SET_FORUM_ANSWER_LIST,
  SET_FORUM_COMMENT_LIST,
  SET_FORUM_LATEST_LIST,
  SET_FORUM_UNANSWERED_LIST,
  UPDATE_FORUM_QUESTION_REQUESTED,
  UPDATE_FORUM_QUESTION_SUCCESSFUL,
  UPDATE_FORUM_QUESTION_FAILED,
  UPDATE_FORUM_ANSWER_REQUESTED,
  UPDATE_FORUM_ANSWER_SUCCESSFUL,
  UPDATE_FORUM_ANSWER_FAILED,
  UPDATE_FORUM_COMMENT_REQUESTED,
  UPDATE_FORUM_COMMENT_SUCCESSFUL,
  UPDATE_FORUM_COMMENT_FAILED,
  SET_FORUM_QUESTION_DATA,
  SET_FORUM_ANSWER_DATA,
  SET_FORUM_COMMENT_DATA,
  SHOW_FORUM_MODAL,
  HIDE_FORUM_MODAL,
  SET_FORUMS_ERROR,
  SEARCH_FORUMS_REQUESTED,
  SEARCH_FORUMS_SUCCESSFUL,
  SEARCH_FORUMS_FAILED,
  SEARCH_FORUMS_TAG_REQUESTED,
  SEARCH_FORUMS_TAG_SUCCESSFUL,
  SEARCH_FORUMS_TAG_FAILED,
  ACCEPT_FORUM_ANSWER_REQUESTED,
  ACCEPT_FORUM_ANSWER_SUCCESSFUL,
  ACCEPT_FORUM_ANSWER_FAILED,
  CLOSE_FORUM_QUESTION_REQUESTED,
  CLOSE_FORUM_QUESTION_SUCCESSFUL,
  CLOSE_FORUM_QUESTION_FAILED,
  GET_SCHOOL_DATA_BY_DOMAIN_REQUESTED,
  GET_SCHOOL_DATA_BY_DOMAIN_SUCCESSFUL,
  GET_SCHOOL_DATA_BY_DOMAIN_FAILED,
  ADD_ANSWER_COMMENT_REQUESTED,
  ADD_ANSWER_COMMENT_SUCCESSFUL,
  ADD_ANSWER_COMMENT_FAILED,
  EDIT_ANSWER_COMMENT_REQUESTED,
  EDIT_ANSWER_COMMENT_SUCCESSFUL,
  EDIT_ANSWER_COMMENT_FAILED,
} from "./action-types"

export const getSchoolDetails = ({ schoolId }) => {
  return {
    types: [
      GET_SCHOOL_DATA_REQUESTED,
      GET_SCHOOL_DATA_SUCCESSFUL,
      GET_SCHOOL_DATA_FAILED,
    ],
    payload: {
      auth: false,
      request: {
        method: "GET",
        url: `/schools/${schoolId}`,
      },
    },
  }
}

export const getSchoolDetailsByDomain = (domain) => {
  return {
    types: [
      GET_SCHOOL_DATA_BY_DOMAIN_REQUESTED,
      GET_SCHOOL_DATA_BY_DOMAIN_SUCCESSFUL,
      GET_SCHOOL_DATA_BY_DOMAIN_FAILED,
    ],
    payload: {
      auth: false,
      request: {
        method: "GET",
        url: `/school/${domain}/`,
      },
    },
  }
}

export const getSchoolCourses = ({ schoolId }) => {
  return {
    types: [
      GET_SCHOOL_COURSES_REQUESTED,
      GET_SCHOOL_COURSES_SUCCESSFUL,
      GET_SCHOOL_COURSES_FAILED,
    ],
    payload: {
      auth: false,
      request: {
        method: "GET",
        url: `/schools/${schoolId}/courses`,
      },
    },
  }
}

export const getCourseDetails = ({ courseId }) => {
  return {
    types: [
      GET_COURSE_DETAILS_REQUESTED,
      GET_COURSE_DETAILS_SUCCESSFUL,
      GET_COURSE_DETAILS_FAILED,
    ],
    payload: {
      auth: false,
      request: {
        method: "GET",
        url: `/courses/${courseId}`,
      },
    },
  }
}

export const getCourseModules = ({ courseId }) => {
  return {
    types: [
      GET_COURSE_MODULES_REQUESTED,
      GET_COURSE_MODULES_SUCCESSFUL,
      GET_COURSE_MODULES_FAILED,
    ],
    payload: {
      auth: false,
      request: {
        method: "GET",
        url: `/courses/${courseId}/modules`,
      },
    },
  }
}

export const getSocials = ({ schoolId }) => {
  return {
    types: [GET_SOCIALS_REQUESTED, GET_SOCIALS_SUCCESSFUL, GET_SOCIALS_FAILED],
    payload: {
      auth: false,
      request: {
        method: "GET",
        url: `/schools/${schoolId}/socials`,
      },
    },
  }
}

export const getSchoolForums = ({ schoolId, page = 1 }) => {
  return {
    types: [GET_FORUMS_REQUESTED, GET_FORUMS_SUCCESSFUL, GET_FORUMS_FAILED],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/schools/${schoolId}/forums/latest?page=${page}`,
      },
    },
  }
}

export const setForumsData = (payload) => {
  return {
    type: SET_FORUMS_DATA,
    payload,
  }
}

export const getSchoolForumsSummary = ({ schoolId }) => {
  return {
    types: [
      GET_FORUMS_SUMMARY_REQUESTED,
      GET_FORUMS_SUMMARY_SUCCESSFUL,
      GET_FORUMS_SUMMARY_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/schools/${schoolId}/forums/summary/`,
      },
    },
  }
}

export const getSchoolForumsUnanswered = ({ schoolId, page = 1 }) => {
  return {
    types: [
      GET_FORUMS_UNANSWERED_REQUESTED,
      GET_FORUMS_UNANSWERED_SUCCESSFUL,
      GET_FORUMS_UNANSWERED_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/schools/${schoolId}/forums/unanswered?page=${page}`,
      },
    },
  }
}

export const setForumsUnansweredData = (payload) => {
  return {
    type: SET_FORUMS_UNANSWERED_DATA,
    payload,
  }
}

export const getQuestionById = (id) => {
  return {
    types: [
      GET_QUESTION_DATA_REQUESTED,
      GET_QUESTION_DATA_SUCCESSFUL,
      GET_QUESTION_DATA_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/forums/questions/${id}/`,
      },
    },
  }
}

export const searchSchoolForums = ({ schoolId, keyword }) => {
  return {
    types: [
      SEARCH_FORUMS_REQUESTED,
      SEARCH_FORUMS_SUCCESSFUL,
      SEARCH_FORUMS_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/schools/${schoolId}/forums/search/?keyword=${keyword}`,
      },
    },
  }
}

export const searchSchoolForumsTag = ({ schoolId, slug }) => {
  return {
    types: [
      SEARCH_FORUMS_TAG_REQUESTED,
      SEARCH_FORUMS_TAG_SUCCESSFUL,
      SEARCH_FORUMS_TAG_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "GET",
        url: `/schools/${schoolId}/forums/tag/${slug}/`,
      },
    },
  }
}

export const showForumModal = (payload) => {
  return {
    type: SHOW_FORUM_MODAL,
    payload,
  }
}

export const closeForumModal = (payload) => {
  return {
    type: HIDE_FORUM_MODAL,
    payload,
  }
}

export const setForumsError = (payload) => {
  return {
    type: SET_FORUMS_ERROR,
    payload,
  }
}

export const submitForumQuestion = (data) => {
  return {
    types: [
      SUBMIT_FORUM_QUESTION_REQUESTED,
      SUBMIT_FORUM_QUESTION_SUCCESSFUL,
      SUBMIT_FORUM_QUESTION_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/forums/questions/`,
        data,
      },
    },
  }
}

export const submitForumComment = (data) => {
  return {
    types: [
      SUBMIT_FORUM_COMMENT_REQUESTED,
      SUBMIT_FORUM_COMMENT_SUCCESSFUL,
      SUBMIT_FORUM_COMMENT_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/forums/question/comments/`,
        data,
      },
    },
  }
}

export const submitForumAnswer = (data) => {
  return {
    types: [
      SUBMIT_FORUM_ANSWER_REQUESTED,
      SUBMIT_FORUM_ANSWER_SUCCESSFUL,
      SUBMIT_FORUM_ANSWER_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/forums/answers/`,
        data,
      },
    },
  }
}

export const upvoteForumQuestion = ({ id, source }) => {
  return {
    types: [
      UPVOTE_FORUM_QUESTION_REQUESTED,
      UPVOTE_FORUM_QUESTION_SUCCESSFUL,
      UPVOTE_FORUM_QUESTION_FAILED,
    ],
    payload: {
      auth: true,
      listSource: source,
      request: {
        method: "POST",
        url: `/forums/questions/${id}/upvote/`,
      },
    },
  }
}

export const downvoteForumQuestion = ({ id, source }) => {
  return {
    types: [
      DOWNVOTE_FORUM_QUESTION_REQUESTED,
      DOWNVOTE_FORUM_QUESTION_SUCCESSFUL,
      DOWNVOTE_FORUM_QUESTION_FAILED,
    ],
    payload: {
      auth: true,
      listSource: source,
      request: {
        method: "POST",
        url: `/forums/questions/${id}/downvote/`,
      },
    },
  }
}

export const upvoteForumAnswer = (id) => {
  return {
    types: [
      UPVOTE_FORUM_ANSWER_REQUESTED,
      UPVOTE_FORUM_ANSWER_SUCCESSFUL,
      UPVOTE_FORUM_ANSWER_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/forums/answers/${id}/upvote/`,
      },
    },
  }
}

export const downvoteForumAnswer = (id) => {
  return {
    types: [
      DOWNVOTE_FORUM_ANSWER_REQUESTED,
      DOWNVOTE_FORUM_ANSWER_SUCCESSFUL,
      DOWNVOTE_FORUM_ANSWER_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/forums/answers/${id}/downvote/`,
      },
    },
  }
}

export const setForumAnswerList = (payload) => {
  return {
    type: SET_FORUM_ANSWER_LIST,
    payload,
  }
}

export const setForumCommentList = (payload) => {
  return {
    type: SET_FORUM_COMMENT_LIST,
    payload,
  }
}

export const setForumLatestList = (payload) => {
  return {
    type: SET_FORUM_LATEST_LIST,
    payload,
  }
}

export const setForumUnansweredList = (payload) => {
  return {
    type: SET_FORUM_UNANSWERED_LIST,
    payload,
  }
}

export const updateForumQuestion = (id, data) => {
  return {
    types: [
      UPDATE_FORUM_QUESTION_REQUESTED,
      UPDATE_FORUM_QUESTION_SUCCESSFUL,
      UPDATE_FORUM_QUESTION_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "PATCH",
        url: `/forums/questions/${id}/`,
        data,
      },
    },
  }
}

export const updateForumAnswer = (id, data) => {
  return {
    types: [
      UPDATE_FORUM_ANSWER_REQUESTED,
      UPDATE_FORUM_ANSWER_SUCCESSFUL,
      UPDATE_FORUM_ANSWER_FAILED,
    ],
    payload: {
      auth: true,
      answerId: id,
      request: {
        method: "PATCH",
        url: `/forums/answers/${id}/`,
        data,
      },
    },
  }
}

export const updateForumComment = (id, data) => {
  return {
    types: [
      UPDATE_FORUM_COMMENT_REQUESTED,
      UPDATE_FORUM_COMMENT_SUCCESSFUL,
      UPDATE_FORUM_COMMENT_FAILED,
    ],
    payload: {
      auth: true,
      commentId: id,
      request: {
        method: "PATCH",
        url: `/forums/question/comments/${id}/`,
        data,
      },
    },
  }
}

export const setForumQuestionData = (payload) => {
  return {
    type: SET_FORUM_QUESTION_DATA,
    payload,
  }
}

export const setForumAnswerData = (payload) => {
  return {
    type: SET_FORUM_ANSWER_DATA,
    payload,
  }
}

export const setForumCommentData = (payload) => {
  return {
    type: SET_FORUM_COMMENT_DATA,
    payload,
  }
}

export const acceptForumAnswer = (id) => {
  return {
    types: [
      ACCEPT_FORUM_ANSWER_REQUESTED,
      ACCEPT_FORUM_ANSWER_SUCCESSFUL,
      ACCEPT_FORUM_ANSWER_FAILED,
    ],
    payload: {
      auth: true,
      answerId: id,
      request: {
        method: "POST",
        url: `/forums/answers/${id}/accept/`,
      },
    },
  }
}

export const closeForumQuestion = (id) => {
  return {
    types: [
      CLOSE_FORUM_QUESTION_REQUESTED,
      CLOSE_FORUM_QUESTION_SUCCESSFUL,
      CLOSE_FORUM_QUESTION_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/forums/questions/${id}/close/`,
      },
    },
  }
}

//
export const addCommentToAnswer = (data) => {
  return {
    types: [
      ADD_ANSWER_COMMENT_REQUESTED,
      ADD_ANSWER_COMMENT_SUCCESSFUL,
      ADD_ANSWER_COMMENT_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "POST",
        url: `/forums/answer/comments/`,
        data,
      },
    },
  }
}

export const editCommentOnAnswer = (data) => {
  return {
    types: [
      EDIT_ANSWER_COMMENT_REQUESTED,
      EDIT_ANSWER_COMMENT_SUCCESSFUL,
      EDIT_ANSWER_COMMENT_FAILED,
    ],
    payload: {
      auth: true,
      request: {
        method: "PATCH",
        url: `/forums/answer/comments/${data.id}/`,
        data,
      },
    },
  }
}
